<template>
  <v-row justify="center">
    <v-col cols="11">
      <v-card class="rounded-xl">
        <v-container>
          <v-row justify="center" align="center">
            
            <v-col cols="4" class="text-right">
              <v-subheader>Cash Username</v-subheader>
            </v-col>
            <v-col cols="8">
              <v-text-field v-model="cash" prefix="$" persistent-hint hint="Cashtag, without the $">
                <template v-slot:prepend>
                  <v-icon color="success">mdi-currency-usd</v-icon>
                </template>
              </v-text-field>
            </v-col>

            <v-col cols="4" class="text-right">
              <v-subheader>Venmo Username</v-subheader>
            </v-col>
            <v-col cols="8">
              <v-text-field v-model="venmo" prefix="@" persistent-hint hint="Venmo Username, without the @">
                <template v-slot:prepend>
                  <v-icon color="info">mdi-cash-usd-outline</v-icon>
                </template>
              </v-text-field>
            </v-col>

            <v-col cols="4" class="text-right">
              <v-subheader>Paypal.me Username</v-subheader>
            </v-col>
            <v-col cols="8">
              <v-text-field v-model="paypal" persistent-hint hint="Paypal.me Username">
                <template v-slot:prepend>
                  <v-icon color="indigo">mdi-alpha-p</v-icon>
                </template>
              </v-text-field>
            </v-col>

            <v-col cols="4" class="text-right">
              <v-subheader>Play sounds</v-subheader>
            </v-col>
            <v-col cols="8">
              <v-switch inset label="Play sounds when saving a bill." v-model="useSoundEffects"></v-switch>
            </v-col>

          </v-row>
        </v-container>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn rounded color="success" @click="save">
            Save
            <v-icon right>mdi-content-save</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
  export default {
    name: 'Accounts',
    data: () => ({
        cash: '', 
        venmo: '', 
        paypal: '', 
        useSoundEffects: false,
    }), 
    methods: {
      save: function(){
        let dataToSave = {
          cash: this.cash, 
          venmo: this.venmo, 
          paypal: this.paypal
        };

        window.localStorage.setItem('accounts', JSON.stringify(dataToSave));
        window.localStorage.setItem('useSoundEffects', JSON.stringify(this.useSoundEffects))

        this.showAlert('Successfully saved accounts!', 'success');
      }, 
      showAlert: function(text, type = 'info'){
				this.$emit('alert', {color: type, text: text});
			},
    }, 
    mounted: function(){
      
      // If localStorage 
      if(window.localStorage.getItem('accounts') != null){

        let savedData = JSON.parse(window.localStorage.getItem('accounts'))

        this.cash = savedData.cash
        this.venmo = savedData.venmo
        this.paypal = savedData.paypal  
      } 

      if(window.localStorage.getItem('useSoundEffects') == null){
        
      } else {
        let soundEffectSettings = JSON.parse(window.localStorage.getItem('useSoundEffects'))

        this.useSoundEffects = soundEffectSettings
      }

    }
  }
</script>